import { AxiosResponse } from 'axios'

export class BadRequest extends Error {
  constructor(public messages: string[], public response: AxiosResponse) {
    super()
    this.name = this.constructor.name
  }
}
